var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.403 22.9304C22.6959 23.2233 23.1708 23.2233 23.4637 22.9304C23.7566 22.6375 23.7566 22.1627 23.4637 21.8698L17.594 16.0001L23.4637 10.1304C23.7566 9.83754 23.7566 9.36266 23.4637 9.06977C23.1708 8.77688 22.6959 8.77688 22.403 9.06977L16.5333 14.9394L10.6637 9.06977C10.3708 8.77687 9.89589 8.77687 9.603 9.06977C9.31011 9.36266 9.31011 9.83753 9.603 10.1304L15.4727 16.0001L9.603 21.8698C9.31011 22.1627 9.31011 22.6375 9.603 22.9304C9.8959 23.2233 10.3708 23.2233 10.6637 22.9304L16.5333 17.0608L22.403 22.9304Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNo);
export default __webpack_public_path__ + "static/media/ico_no.d86fddd9cf2a84e6969ade7446835ce7.svg";
export { ForwardRef as ReactComponent };